<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sec_front"><a id="page_xi"></a><span class="bold">Maps</span></h2>
<p class="noindent">North Africa</p>
<p class="noindentt">Italy and the Adriatic</p>
<p class="noindentt">Burma</p>
<p class="noindentt">Operation Jaywick</p>
<p class="noindentt">The First Chindit Expedition</p>
<p class="noindentt">The Second Chindit Expedition</p>
<p class="noindentt">Greece and the Aegean</p>
<p class="noindentt">France (and insert: Operation Freshman)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Maps.vue?3e1101ec